import Vue from 'vue'
import VueRouter from 'vue-router'
import NProgress from "nprogress";
import Home from '../views/Home/Home.vue'
import Shop from '../views/Shop/Shop.vue'
import SingleProduct from '../views/SingleProduct/SingleProduct.vue'
import Login from '../views/Login/Login.vue'
import Register from '../views/Register/Register.vue'
import MiniCart from '../views/MiniCart/MiniCart.vue'
import MyAccount from '../views/MyAccount/MyAccount.vue'
import Checkout from '../views/Checkout/Checkout.vue'
import NewPassword from '../views/NewPassword/NewPassword.vue'
import Profil from '../views/Profil/Profil.vue'
import MyCotations from '../views/MyCotations/MyCotations.vue'
import CotationEdit from '../views/MyCotations/CotationEdit.vue'
import CotationShow from '../views/MyCotations/CotationShow.vue'
import Devis from '../views/MyCotations/Devis.vue'
import DevisShow from '../views/MyCotations/DevisShow.vue'

import store from "../store";

import Errors from "@/modules/errors/route/routes";

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: Home,
    meta: {
      Auth: true
    }
  },
  {
    path: '/shop/:family?/:subfamily?',
    name: 'shop',
    component: Shop
  },
  {
    path: '/product',
    name: 'SingleProduct',
    component: SingleProduct
  },
  {
    path: '/login/:email?/:password?',
    name: 'login',
    component: Login,
    meta: {
      layout: "auth"
  },
    beforeEnter: (to, from, next) => {
      if (!store.getters["auth/isLoggedIn"]) next();
      else next({ name: "home" });
  }
  },
  {
    path: '/register',
    name: 'Register',
    component: Register
  },
  {
    path: '/mini-cart',
    name: 'mini-cart',
    component: MiniCart,
    meta: {
      Auth: true,
      layout: "simple"
    }
  },

  {
    path: '/my-account',
    name: 'MyAccount',
    component: MyAccount
  },
  {
    path: '/profil',
    name: 'profil',
    component: Profil,
    meta: {
      Auth: true,
      layout: "simple"
    }
  },

  {
    path: '/cotations',
    name: 'cotations',
    component: MyCotations,
    meta: {
      Auth: true
    }
  },
  {
    path: '/cotation-edit/:id',
    name: 'cotation-edit',
    component: CotationEdit,
    meta: {
      Auth: true,
      layout: "simple"
    }
  },
  {
    path: '/cotation-show/:id',
    name: 'cotation-show',
    component: CotationShow,
    meta: {
      Auth: true,
      layout: "simple"
    }
  },

  {
    path: "/my-devis",
    name: "my-devis",
    component: Devis,
    meta: {
        Auth: true
    }
  },
  {
    path: "/devis/show/:uuid/:type",
    name: "devis-show",
    component: DevisShow,
    meta: {
        Auth: true
    }
  },


  {
    path: '/checkout',
    name: 'Checkout',
    component: Checkout
  },
  {
    path: '/new-password',
    name: 'NewPassword',
    component: NewPassword,
    meta: {
      layout: "auth"
  },
  },
  // {
  //   path: '/about',
  //   name: 'About',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  // }
  ...Errors,
]

const router = new VueRouter({
  mode: 'history',
  linkActiveClass: "active",
  routes
});



router.beforeResolve((to, from, next) => {
  // If this isn't an initial page load.
  if (to.name) {
    // Start the route progress bar.
    NProgress.start();
  }
  next();
});

router.beforeEach((to, from, next) => {
    if (to.matched.some(record => record.meta.Auth)) {
        //page qui necessité d'être connecté
        if (!store.getters["auth/isLoggedIn"]) {
            //redirection sur login s'il n'est pas connecté
            next({ name: "login" });
        } else {
            if (!to.meta.permission) {
                next();
            }else if (store.getters["auth/isClient"]) {
                //on le laisse passer

                next();
                //  console.log(to.meta.permission);
            }else{
                next({ name: "page403" });
            }
        }
    } else {
        next();
    }
});

router.afterEach(() => {
    // Complete the animation of the route progress bar.
    NProgress.done();
});

export default router
